import { render } from "./Sign.vue?vue&type=template&id=012a9a62&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"

import "./Sign.vue?vue&type=style&index=0&id=012a9a62&scoped=true&lang=css"

import exportComponent from "/Users/chencheng/code/bethlehem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012a9a62"]])

export default __exports__